<template>
    <div>
        <div class="header" @click="goBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10.494" viewBox="0 0 6 10.494"><path id="Icon_ionic-ios-arrow-forward" data-name="Icon ionic-ios-arrow-forward" d="M13.055,11.441l3.971-3.968a.747.747,0,0,0,0-1.059.756.756,0,0,0-1.062,0l-4.5,4.5a.749.749,0,0,0-.022,1.034l4.518,4.527a.75.75,0,0,0,1.062-1.059Z" transform="translate(-11.246 -6.196)" fill="#ec1c24"/></svg>
            <span>Retour à la recherche</span>
        </div>
        <div class="directions-header">
            <div class="navigation-icons tw-grid tw-grid-cols-4 tw-gap-8">
                <div class="icon" :class="{'active' : directionsMode == 'car'}" @click="getDirections('car')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24.641" height="19.713" viewBox="0 0 24.641 19.713"><path d="M22.519,12.115l-.577-1.443L20.919,8.114A5.722,5.722,0,0,0,15.581,4.5H9.061A5.722,5.722,0,0,0,3.722,8.114L2.7,10.672l-.577,1.443A3.278,3.278,0,0,0,0,15.178v2.464a3.259,3.259,0,0,0,.821,2.153V22.57a1.643,1.643,0,0,0,1.643,1.643H4.107A1.643,1.643,0,0,0,5.75,22.57V20.928H18.892V22.57a1.643,1.643,0,0,0,1.643,1.643h1.643A1.643,1.643,0,0,0,23.82,22.57V19.795a3.257,3.257,0,0,0,.821-2.153V15.178A3.278,3.278,0,0,0,22.519,12.115ZM6.773,9.334A2.464,2.464,0,0,1,9.061,7.786h6.52a2.464,2.464,0,0,1,2.288,1.549l1.023,2.558H5.75L6.773,9.334Zm-2.666,8.3a1.55,1.55,0,0,1-1.643-1.638,1.55,1.55,0,0,1,1.643-1.638,3.16,3.16,0,0,1,2.464,2.456C6.571,17.8,5.093,17.632,4.107,17.632Zm16.428,0c-.986,0-2.464.164-2.464-.819a3.16,3.16,0,0,1,2.464-2.456,1.55,1.55,0,0,1,1.643,1.638,1.55,1.55,0,0,1-1.643,1.638Z" transform="translate(0 -4.5)"/></svg>
                </div>
                <div class="icon" :class="{'active' : directionsMode == 'public'}" @click="getDirections('public')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.81" height="22.229" viewBox="0 0 18.81 22.229"><path d="M15.03,3.375c-4.7,0-9.4.582-9.4,4.681V19.171A4.1,4.1,0,0,0,9.74,23.264L7.976,25.017V25.6H10.6l2.351-2.341h4.43L19.732,25.6h2.351v-.582L20.32,23.269a4.108,4.108,0,0,0,4.115-4.093V8.061C24.435,3.957,20.224,3.375,15.03,3.375ZM9.74,20.923A1.753,1.753,0,1,1,11.5,19.171,1.756,1.756,0,0,1,9.74,20.923Zm4.115-8.186H7.976V8.056h5.878Zm2.351,0V8.056h5.878v4.681Zm4.115,8.186a1.753,1.753,0,1,1,1.763-1.753A1.756,1.756,0,0,1,20.32,20.923Z" transform="translate(-5.625 -3.375)"/></svg>
                </div>
                <div class="icon" :class="{'active' : directionsMode == 'walking'}" @click="getDirections('walking')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.195" height="24.312" viewBox="0 0 15.195 24.312"><path d="M9.876,4.558A2.279,2.279,0,1,0,7.6,2.279,2.28,2.28,0,0,0,9.876,4.558Zm4.487,7.079-1.106-.56-.461-1.4a5.177,5.177,0,0,0-4.852-3.6,10.44,10.44,0,0,0-4.43,1.2,4.529,4.529,0,0,0-2.36,2.193l-.318.646A1.524,1.524,0,0,0,1.51,12.15a1.5,1.5,0,0,0,2.018-.679l.318-.646a1.509,1.509,0,0,1,.783-.731L5.9,9.581,5.18,12.463a3.049,3.049,0,0,0,.707,2.792L8.732,18.36a3.064,3.064,0,0,1,.707,1.315l.869,3.48a1.519,1.519,0,1,0,2.948-.736L12.2,18.194a3.037,3.037,0,0,0-.707-1.315l-2.16-2.36.817-3.262.261.783A3.028,3.028,0,0,0,11.918,13.8l1.106.56a1.5,1.5,0,0,0,2.018-.679,1.537,1.537,0,0,0-.679-2.042ZM3.495,18.317a2.946,2.946,0,0,1-.674,1.021L.447,21.716a1.519,1.519,0,0,0,2.146,2.151l2.82-2.82a3.086,3.086,0,0,0,.674-1.021l.641-1.6c-2.626-2.863-1.837-1.985-2.25-2.55l-.983,2.445Z" transform="translate(-0.002)"/></svg>
                </div>
                <div class="icon" :class="{'active' : directionsMode == 'cycling'}" @click="getDirections('cycling')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25.873" height="22.177" viewBox="0 0 25.873 22.177"><g transform="translate(0 0)"><path d="M7.638,19.99A3.8,3.8,0,1,1,4.976,21.1,3.746,3.746,0,0,1,7.638,19.99m0-1.617a5.391,5.391,0,1,0,5.388,5.394,5.405,5.405,0,0,0-5.388-5.394Z" transform="translate(-2.25 -6.978)"/><path d="M22.084,8.185a1.839,1.839,0,0,0,1.848-1.848A1.819,1.819,0,0,0,22.1,4.5a1.842,1.842,0,1,0-.012,3.685Z" transform="translate(-5.463 -4.5)"/><path d="M26.018,19.99A3.8,3.8,0,1,1,23.356,21.1a3.746,3.746,0,0,1,2.662-1.115m0-1.617a5.388,5.388,0,1,0,5.388,5.388,5.405,5.405,0,0,0-5.388-5.388Z" transform="translate(-5.533 -6.978)"/></g><path d="M23.263,12.545H20.49l-1.7-3.471a1.807,1.807,0,0,0-2.859-.381l-4.141,3.991a1.881,1.881,0,0,0-.537,1.294,1.721,1.721,0,0,0,1.068,1.565c2.628,1.513,3.552,1.681,3.552,2.437v3.806a.924.924,0,0,0,1.848,0v-5.2c0-.762-1.756-1.386-2.789-2.195l2.824-2.974c1.08,1.646,1.577,2.974,2.195,2.974h3.315a.924.924,0,1,0,0-1.848Z" transform="translate(-3.858 -5.153)"/></svg>
                </div>
            </div>
            <div class="navigation-address">
                <p>{{ $store.state.userAddress }}</p>
                <p>{{ $store.state.selectedStore.name }}</p>
            </div>
        </div>
        <div class="navigation-main-info">
            <p v-if="'distance' in route && 'duration' in route"><strong>{{ route.duration.text }}</strong> ({{ route.distance.text }})</p>
        </div>
        <div class="navigation-instructions" id="navigation-instructions" v-show="steps"></div>
        <div class="navigation-instructions" v-show="!steps">
            <h1>Itinéraire indisponible</h1>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            route: {},
            steps: true,
            directionsMode: 'car',

            directionsService: undefined,
            directionsDisplay: undefined,
        };
    },
    methods: {
        getDirections(mode) {
            let travelMode;
            this.directionsMode = mode;

            switch (mode) {
            case 'car':
                travelMode = this.$store.state.google.maps.DirectionsTravelMode.DRIVING;
                break;
            case 'public':
                travelMode = this.$store.state.google.maps.DirectionsTravelMode.TRANSIT;
                break;
            case 'walking':
                travelMode = this.$store.state.google.maps.DirectionsTravelMode.WALKING;
                break;
            case 'cycling':
                travelMode = this.$store.state.google.maps.DirectionsTravelMode.BICYCLING;
                break;

            default:
                travelMode = this.$store.state.google.maps.DirectionsTravelMode.DRIVING;
                break;
            }
            const request = {
                origin: this.$store.state.userPosition,
                destination: this.$store.state.selectedStore.location,
                travelMode,
                provideRouteAlternatives: false,
            };
            this.directionsService.route(request, (response, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    // eslint-disable-next-line prefer-destructuring
                    this.route = response.routes[0].legs[0];
                    this.directionsDisplay.setDirections(response);
                    this.steps = true;
                } else {
                    console.log('nope');
                    this.steps = false;
                }
            });
        },
        goBack() {
            this.$store.state.view = 'search';
            this.directionsDisplay.setMap(null);
            this.$store.state.map.setZoom(this.$store.state.zoomLevel);
            this.$store.state.map.setCenter(this.$store.state.userPosition);
        },
    },
    mounted() {
        this.directionsService = new this.$store.state.google.maps.DirectionsService();
        this.directionsDisplay = new this.$store.state.google.maps.DirectionsRenderer({
            map: this.$store.state.map,
            panel: document.getElementById('navigation-instructions'),
            suppressMarkers: true,
        });

        this.getDirections('car');
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';

.header {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: #e5e5e5;
    font-size: 12px;
    font-family: 'Helvetica';
    cursor: pointer;

    svg {
        margin-right: 10px;
        height: 11px;
    }
}
.directions-header {
    padding: 30px 20px 0 20px;
    background-color: $light_gray;
    font-family: 'Helvetica';

    .navigation-icons {
        margin-bottom: 25px;

        .icon {
            max-width: 50px;
            width: 100%;
            border-bottom: 3px solid #dadada;
            cursor: pointer;
            transition: .15s;

            @apply tw-mx-auto;

            svg {
                margin-right: auto;
                margin-bottom: 12px;
                margin-left: auto;
                height: 20px;
                transition: .15s;

                fill: $text_gray;
            }
            &.active, &:hover {
                border-color: $main_color;
                svg {
                    fill: $main_color;
                }
            }
        }
    }
    .navigation-address {
        position: relative;
        padding-left: 27px;

        &:before {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 27px;
            background-image: url(~@/assets/img/directions.svg);
            background-position: left center;
            background-size: contain;
            background-repeat: no-repeat;
            content: '';
        }
        p {
            margin-bottom: 22px;
            padding-bottom: 8px;
            padding-left: 3px;
            border-bottom: 3px solid #e0e0e0;
            color: $text_gray;
            font-size: 13px;
            line-height: 1;
        }
    }
}
.navigation-main-info {
    padding: 30px 20px;
    border-bottom: 1px solid $light_gray;
    background-color: #fff;

    p {
        color: $text_gray;
        strong {
            color: $main_color;
            font-weight: 700;
            font-size: 18px;
        }
    }
}
.navigation-instructions {
    overflow: auto;
    padding: 0 20px;
    max-height: 413px;
    background-color: #fff;

    .adp {
        &-summary, &-placemark, &-legal {
            display: none;
        }

        table {
            color: $text_gray;
            tr {
                &::before, &::after {
                    border-color: $light_gray !important;
                }
            }
        }
        *, ::before, ::after {
            border-color: $light_gray !important;
        }
    }
}

</style>
